export const SET_COGNITO_USER = 'SET_COGNITO_USER';
